export const Next = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="17" viewBox="0 0 10 17" fill="none">
            <path
                d="M1.24124 3.09303L6.64241 8.59042L1.24124 14.0878C0.698341 14.6404 0.698341 15.533 1.24124 16.0856C1.78414 16.6381 2.66114 16.6381 3.20404 16.0856L9.59356 9.58221C10.1365 9.02964 10.1365 8.13702 9.59356 7.58445L3.20404 1.0811C2.66114 0.528524 1.78414 0.528524 1.24124 1.0811C0.712262 1.63367 0.698341 2.54045 1.24124 3.09303Z"
                fill="#575757"
            />
        </svg>
    );
};
